export enum ChamberType {
  None = 0,
  Classic = 1,
  XL = 2,
  Performance = 3,
}
